
import { Pagination, PaginationProps } from "antd";
import React from "react";

const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
  if (type === 'prev') {
    return <a>Previous</a>;
  }
  if (type === 'next') {
    return <a>Next</a>;
  }
  return originalElement;
};

PaginationWidget.defaultProps = {
  totalItems: 25,
  maxItemsPerPage: 25
}

export default function PaginationWidget(
  props: {
    totalItems?: number,
    current: number,
    maxItemsPerPage?: number,
    pageChange;
  }
) {
  const {totalItems, current, maxItemsPerPage} = props;

  const onChange: PaginationProps['onChange'] = (page) => {
    props.pageChange(page);
  };

  return <Pagination 
            align="center" 
            total={totalItems} 
            itemRender={itemRender} 
            defaultPageSize={maxItemsPerPage} 
            showSizeChanger={false}
            defaultCurrent={1}
            current={current}
            onChange={onChange}/>
}